<template>
    <div class="bg-white form-sample new-activity">
        <b-overlay
            :show="toggleOverlay || showOverlay || is_mounting"
            rounded="sm"
        >
            <b-card-body v-if="isNew">
                <div class="d-flex title-bar-block">
                    <div class="icon-block me-4">
                        <button
                            v-b-tooltip.hover
                            :title="$backLabel()"
                            @click="cancel()"
                        >
                            <i
                                class="fa fa-chevron-left text-white"
                                aria-hidden="true"
                            ></i>
                        </button>
                    </div>
                    <div class="text">
                        <span class="me-2"
                            >{{ $translate('new_activity') }}
                        </span>
                    </div>
                </div>
                <div>
                    <portal-target name="OrderSummaryView"> </portal-target>
                </div>
            </b-card-body>

            <b-col
                cols="12"
                class="bg-white mt-3 p-3 view-list form-sample"
                v-else
            >
                <b-row
                    class="d-flex justify-content-between inner-view title-bar-block"
                >
                    <b-col sm="6" md="6" lg="9" class="title-box">
                        <div class="d-flex">
                            <div class="icon-block me-4">
                                <button
                                    v-b-tooltip.hover
                                    :title="$backLabel()"
                                    @click="cancel()"
                                >
                                    <i
                                        class="fa fa-chevron-left text-white"
                                        aria-hidden="true"
                                    ></i>
                                </button>
                            </div>
                            {{ orderType && orderType.name }}
                            &nbsp;
                            <small>
                                <b-badge :variant="order | filterStatusVariant">
                                    {{ filterStatusName(order) }}</b-badge
                                ><span>
                                    {{
                                        order.completed_at | filterLocalDateTime
                                    }}</span
                                >
                            </small>
                        </div>
                    </b-col>
                    <b-col sm="6" md="6" lg="3" class="text-right">
                        <page-actions
                            :buttons-actions="viewButtons"
                            :dropdown-actions="otherActions"
                            control-size="sm"
                            :dropdown-disabled="isNew"
                            :align="'justify-content-end'"
                        />
                    </b-col>
                    <!-- </div> -->
                </b-row>
                <div class="accordion mt-3">
                    <b-card no-body class="accordion-box">
                        <div>
                            <a
                                class="accordion-header"
                                :class="{
                                    'active-accordion':
                                        activeAccordion === 'summary',
                                }"
                                @click="activateAccordion('summary')"
                                >{{ $translate('summary') }}</a
                            >
                        </div>
                        <b-collapse
                            :visible="activeAccordion === 'summary'"
                            class="accordion-content"
                        >
                            <portal-target name="OrderSummaryView">
                            </portal-target>
                        </b-collapse>
                    </b-card>

                    <b-card no-body class="accordion-box">
                        <div>
                            <a
                                class="accordion-header"
                                :class="{
                                    'active-accordion':
                                        activeAccordion === 'location',
                                }"
                                @click="activateAccordion('location')"
                                >{{ $translate('location') }}</a
                            >
                        </div>
                        <b-collapse
                            :visible="activeAccordion === 'location'"
                            class="accordion-content"
                        >
                            <portal-target
                                name="deliveryLocationView"
                            ></portal-target>
                        </b-collapse>
                    </b-card>

                    <b-card no-body class="accordion-box" v-if="hasLinks">
                        <div>
                            <a
                                class="accordion-header"
                                :class="{
                                    'active-accordion':
                                        activeAccordion === 'links',
                                }"
                                @click="activateAccordion('links')"
                                >{{ $translate('Associated Activities') }}</a
                            >
                        </div>
                        <b-collapse
                            :visible="activeAccordion === 'links'"
                            class="accordion-content"
                        >
                            <activity-links
                                v-if="activeAccordion === 'links'"
                                @change-activity="changeOrder"
                                :order="order"
                            ></activity-links>
                        </b-collapse>
                    </b-card>

                    <b-card no-body class="accordion-box inner-accordian">
                        <div>
                            <a
                                class="accordion-header"
                                :class="{
                                    'active-accordion':
                                        activeAccordion === 'details',
                                }"
                                @click="activateAccordion('details')"
                                >{{ $translate('details') }}</a
                            >
                        </div>
                        <b-collapse
                            :visible="activeAccordion === 'details'"
                            class="accordion-content"
                        >
                            <portal-target name="OrderItemsView">
                            </portal-target>
                        </b-collapse>
                    </b-card>

                    <b-card no-body class="accordion-box">
                        <div>
                            <a
                                class="accordion-header"
                                :class="{
                                    'active-accordion':
                                        activeAccordion === 'messages',
                                }"
                                @click="activateAccordion('messages')"
                                >{{ $translate('messages') }}</a
                            >
                        </div>
                        <b-collapse
                            :visible="activeAccordion === 'messages'"
                            class="accordion-content"
                        >
                            <portal-target name="OrderMessagesView">
                            </portal-target>
                        </b-collapse>
                    </b-card>

                    <b-card no-body class="accordion-box">
                        <div>
                            <a
                                class="accordion-header"
                                :class="{
                                    'active-accordion':
                                        activeAccordion === 'attachments',
                                }"
                                @click="activateAccordion('attachments')"
                                >{{ $translate('attachments') }}</a
                            >
                        </div>
                        <b-collapse
                            :visible="activeAccordion === 'attachments'"
                            class="accordion-content"
                        >
                            <portal-target name="OrderAttachmentsView">
                            </portal-target>
                        </b-collapse>
                    </b-card>

                    <b-card no-body class="accordion-box">
                        <div>
                            <a
                                class="accordion-header"
                                :class="{
                                    'active-accordion':
                                        activeAccordion === 'reviews',
                                }"
                                @click="activateAccordion('reviews')"
                                >{{ $translate('reviews') }}</a
                            >
                        </div>

                        <b-collapse
                            :visible="activeAccordion === 'reviews'"
                            class="accordion-content"
                        >
                            <view-checkoffs
                                :view-mode="viewMode"
                                :is-new="isNew"
                            ></view-checkoffs>
                        </b-collapse>
                    </b-card>

                    <b-card no-body class="accordion-box">
                        <div>
                            <a
                                class="accordion-header"
                                :class="{
                                    'active-accordion':
                                        activeAccordion === 'receivedBy',
                                }"
                                @click="activateAccordion('receivedBy')"
                                >{{ $translate('received_by') }}</a
                            >
                        </div>
                        <b-Collapse
                            :visible="activeAccordion === 'receivedBy'"
                            class="accordion-content"
                        >
                            <view-received-by :order="order" />
                        </b-Collapse>
                    </b-card>
                    <b-card
                        no-body
                        class="accordion-box"
                        v-if="!!order.feedback"
                    >
                        <div>
                            <a
                                class="accordion-header"
                                :class="{
                                    'active-accordion':
                                        activeAccordion === 'feedback',
                                }"
                                @click="activateAccordion('feedback')"
                                >{{ $translate('feedback') }}</a
                            >
                        </div>
                        <b-Collapse
                            :visible="activeAccordion === 'feedback'"
                            class="accordion-content"
                        >
                            <b-col class="mt-3">
                                <label for="group-feedback" class="mb-3">
                                    <strong>{{
                                        $translate('feedback')
                                    }}</strong>
                                </label>
                                <b-form-rating
                                    body-class="p-0 text-left"
                                    id="input-feedback"
                                    v-model="order.feedback"
                                    disabled
                                >
                                </b-form-rating>
                            </b-col>
                            <b-col class="mt-3">
                                <label
                                    for="input-feedback-comments"
                                    class="mb-3"
                                    ><strong>{{
                                        $translate('feedback_comments')
                                    }}</strong></label
                                >
                                <b-form-textarea
                                    id="input-description"
                                    rows="3"
                                    max-rows="4"
                                    v-model="order.feedback_comments"
                                    disabled
                                ></b-form-textarea>
                            </b-col>
                        </b-Collapse>
                    </b-card>
                    <b-card no-body class="accordion-box">
                        <div>
                            <a
                                class="accordion-header"
                                :class="{
                                    'active-accordion':
                                        activeAccordion === 'audit_logs',
                                }"
                                @click="activateAccordion('audit_logs')"
                                >{{ $translate('audit_logs') }}</a
                            >
                        </div>
                        <b-Collapse
                            :visible="activeAccordion === 'audit_logs'"
                            class="accordion-content"
                        >
                            <b-col>
                                <b-table
                                    responsive
                                    :fields="fields"
                                    :items="order.audit_logs"
                                >
                                    <template #cell(user)="{ item }">
                                        <span>
                                            {{
                                                `${item.user.first_name} ${item.user.last_name}`
                                            }}
                                        </span>
                                    </template>

                                    <template #cell(message)="{ item }">
                                        <span
                                            class="lh-base"
                                            v-html="item.message"
                                        ></span>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-Collapse>
                    </b-card>
                </div>
            </b-col>
        </b-overlay>

        <ReportsDialog
            ref="reportsDialog"
            :order-id="order.id"
            :statement-type="STATEMENT_TYPES[reportStatment.type]"
            :title="reportStatment.title"
        />

        <create-template-from-order />

        <portal to="OrderSummaryView">
            <view-order-summary
                ref="ord-sum-ref"
                :view-mode="viewMode"
                :updating="updating"
                @change-mode="viewMode = $event"
            />
        </portal>

        <portal to="deliveryLocationView">
            <location-section
                v-model="delivery_location_section_id"
                :hide-controls="!isNew"
                @update-section-model="evt => (deliveryLocation = evt)"
                :disabled="!(isNew || !viewMode)"
            >
            </location-section>
        </portal>

        <portal to="OrderItemsView">
            <manage-order-items
                :view-mode="viewMode"
                :order_template_id="order_template_id"
                :is-new="isNew"
                :order="order"
                @change-mode="viewMode = $event"
                :customer-assets="customerAssets"
            />
        </portal>

        <portal to="OrderMessagesView">
            <view-notes :view-mode="viewMode" :is-new="isNew" />
        </portal>

        <portal to="OrderAttachmentsView">
            <view-attachments :view-mode="viewMode" :is-new="isNew" />
        </portal>

        <b-modal
            id="convertOrderType"
            v-model="isConvertOrderType"
            header-class="p-0"
            footer-class="d-flex justify-content-center border-0"
            content-class="custom-model-wrap"
            @ok="convertOrderType"
        >
            <template #modal-title="{ cancel }">
                <div class="title-block text-center p-2">
                    {{ $translate('convert_activity_title') }}
                </div>
                <button @click="cancel()" class="close-btn">x</button>
            </template>
            <template #default>
                <b-col class="dd">
                    <label class="mb-3"
                        ><strong
                            >{{ $translate('type')
                            }}<span class="red">*</span></strong
                        ></label
                    >
                    <b-form-select
                        class="form-control"
                        id="input-type"
                        v-model="new_order_type_id"
                        :options="orderTypes | mapOptions"
                        required
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>{{
                                $translate('select_new_activity_type')
                            }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </template>
            <template #modal-footer="{ ok, cancel }">
                <b-button variant="info" class="btn-fw" @click="ok()">{{
                    $translate('ok')
                }}</b-button>
                <b-button variant="info" class="btn-fw" @click="cancel()">{{
                    $cancelLabel()
                }}</b-button>
            </template>
        </b-modal>

        <div class="ps-3 mt-4 d-flex justify-content-center gap-2">
            <b-button v-if="hasPermissionCreate && isNew" @click="createNewOrder" class="me-2 btn-fw" variant="info"
                :disabled="updating || toggleOverlay || showOverlay || is_mounting">{{
                    updating
                        ? this.$translate('creating_new_activity')
                        : this.$translate('create_new_activity')
                }}</b-button
            >
            <b-button v-if="showLocationBtn" @click="setLocationSearchMode" variant="info" class="me-2"
                :disabled="viewMode || updating ">{{ this.$translate('change_location') }}</b-button>

            <b-button v-if="showUpdateBtn && hasPermissionUpdate" variant="info" @click="runSaveAction" class="btn-fw"
                :disabled="updating || viewMode || toggleOverlay || showOverlay || is_mounting">{{
                    updating
                        ? this.$translate('saving_changes')
                        : this.$translate('save_changes')
                }}</b-button
            >
            <b-button variant="info" @click="cancel()" class="btn-fw">{{
                $cancelLabel()
            }}</b-button>
        </div>
    </div>
</template>
<script>
import EventBus from '@/exports/event-bus.js'
import api from '@/api/order'
import CreateTemplateFromOrder from '@/components/CreateTemplateFromOrder.vue'
import ManageOrderItems from './ManageOrderItems.vue'
import ViewNotes from './ViewNotes.vue'
import ViewAttachments from './ViewAttachments.vue'
import ViewReceivedBy from './ViewReceivedBy.vue'
///import moment from 'moment'
import PageActions from '@/components/PageActions.vue'
import ReportsDialog from '@/components/ReportsDialog.vue'

import LocationSection from '@/views/Location/LocationSection'
import ViewOrderSummary from './ViewOrderSummary'
import ViewCheckoffs from './ViewCheckoffs.vue'
import ActivityLinks from './ActivityLinks.vue'
//mixins
import dateTimeMixins from '@/mixins/dateTimeMixins'
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
//report templates
import { STATEMENT_TYPES } from '@/exports/jsreport_templates'
import moment from 'moment'

const tabNames = [
    'summary', // 0,
    'location', // 1,
    'items', // 2,
    'messages', // 3,
    'attachments', // 4,
    'reviews', // 5,
    'receivedBy', // 6,
]
export default {
    name: 'orders-view',
    components: {
        CreateTemplateFromOrder,
        ManageOrderItems,
        ViewNotes,
        LocationSection,
        ViewAttachments,
        ViewReceivedBy,
        ViewOrderSummary,
        ViewCheckoffs,
        PageActions,
        ReportsDialog,
        ActivityLinks,
    },
    mixins: [
        dateTimeMixins,
        popupMixins,
        utilityMixins,
        permissionsMixins,
        // reportMixins,
    ],
    data() {
        return {
            tabIdx: 0,
            tabNames,
            activeAccordion: 'summary',
            viewMode: true,
            delivery_location_section_id: null,
            order_type_id: null,
            new_order_type_id: null,
            order_template_id: null,
            formStatus: {},
            driverModified: false,
            updating: false,
            toggleOverlay: false,
            summaryChanged: false,
            deliveryLocation: {},
            previousModel: null,
            customerAssets: [],
            isConvertOrderType: false,
            is_mounting: false,
            STATEMENT_TYPES,
            reportStatment: {},
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },

        filterStatusVariant(item) {
            return item.completed
                ? 'success'
                : item.released
                ? 'primary'
                : 'danger'
        },
        mapOptions(arr, isUser) {
            return arr.map(x => ({
                value: x.id,
                text: isUser ? `${x.first_name} ${x.last_name}` : x.name,
            }))
        },
    },

    computed: {
        fields() {
            return [
                {
                    key: 'created_at',
                    label: this.$translate('date'),
                    formatter: (value, key, item) =>
                        moment(new Date(item.created_at)).format(
                            'YYYY-MM-DD hh:mm:A'
                        ),
                },
                { key: 'type', label: this.$translate('type') },
                { key: 'user', label: this.$translate('user') },
                { key: 'message', label: this.$translate('messages') },
            ]
        },
        hasLinks() {
            return (
                (this.order.secondary_orders || []).length +
                    (this.order.primary_orders || []).length >
                0
            )
        },
        componentName() {
            return this.$translate('activity')
        },
        viewButtons() {
            const actions = []
            if (!this.isNew) {
                actions.push({
                    action: () => this.toggleView(),
                    icon: this.viewMode ? 'pencil' : 'eye',
                    faIcon: this.viewMode ? 'fa fa-pencil-square' : 'fa fa-eye',
                    variant: 'light',
                    tooltip: this.viewMode
                        ? this.$translate('switch_to_edit_state')
                        : this.$translate('switch_to_view_state'),
                })
            }
            actions.push({
                action: () => this.launchNewOrder(),
                icon: 'plus-circle',
                faIcon: 'fa fa-plus-circle me-2',
                variant: 'light',
                size: 'sm',
                tooltip: this.$translate('create_new_activity'),
            })
            return actions
        },
        otherActions() {
            const actions = []

            actions.push({
                action: () => this.cancelOrder(),
                text: this.$translate('cancel_activity'),
            })
            actions.push({
                action: () => this.toggleCompletion(),
                text: this.order.completed
                    ? this.$translate('mark_as_incomplete')
                    : this.$translate('mark_as_complete'),
                disabled: this.viewMode,
            })
            actions.push({
                action: () => this.releaseActivity(),
                text: this.$translate('release_activity'),
                disabled: this.viewMode,
            })
            if (this.hasPermissionCreate) {
                actions.push({
                    action: () => this.openConvertOTModal(),
                    text: this.$translate('convert_activity'),
                    disabled: this.viewMode,
                })
            }
            if (
                this.hasPermissionUpdate &&
                this.orderItems.length > 0 &&
                this.orderItems.some(x => x.id)
            ) {
                actions.push({
                    action: () => this.showOrderTemplateModal(),
                    text: this.$translate('create_template'),
                    disabled: this.viewMode,
                })

                actions.push({
                    action: () => this.processReport(0, 'Download Invoice'),
                    text: this.$translate('download_invoice'),
                    disabled: this.viewMode,
                })
                if (this.isCustomStatement) {
                    actions.push({
                        action: () =>
                            this.processReport(1, 'Download Statement'),
                        text: this.$translate('download_statement'),
                        disabled: this.viewMode,
                    })
                } else {
                    actions.push({
                        action: () =>
                            this.processReport(2, 'Download Statement'),
                        text: this.$translate('download_statement'),
                        disabled: this.viewMode,
                    })
                }
            }
            if (this.hasPermissionDelete) {
                actions.push({
                    action: () => this.deleteOrder(),
                    text: this.$translate('delete_activity'),
                    disabled: this.viewMode,
                })
            }
            return actions
        },

        isCustomStatement() {
            return !!(this.taskTypeValue && this.taskTypeValue.isTaskType)
        },

        entities() {
            const _entities = this.$store.getters['transactionType/entities']
            console.log('----entities', _entities)
            return _entities
        },
        entity() {
            ///// this.orderTypes.find(x => x.id === this.order.order_type_id) ||
            const { orderTypes, order_type_id, orderType } = this
            console.log('order type----', {
                orderTypes,
                orderType,
                order_type_id,
            })
            return (
                orderType &&
                orderType.transaction_type &&
                orderType.transaction_type.entity
            )
        },
        orderTypes() {
            return this.$store.getters['orderType/activityTypesByPermission']
        },
        showOverlay() {
            return this.$store.state.orders.orderLoadingState
        },

        order() {
            return this.$store.state.orders.item
        },

        orderItems() {
            return this.$store.state.orders.orderItems
        },

        orderId() {
            return this.$route.params.id
        },

        isNew() {
            return !(this.$route.params.id > 0)
        },

        orderType() {
            const { orderTypes, order_type_id } = this

            if (orderTypes && orderTypes.length > 0 && order_type_id) {
                return orderTypes.find(x => x.id === order_type_id)
            }

            return null // or return a default object or value, if desired
        },

        storedItems() {
            return this.$store.state.orderItemStore.items
        },
        arrangedItems() {
            return this.$store.state.orderItemStore.arranged_items
        },
        orderChanged() {
            return this.$store.state.orderItemStore.orderChanged
        },

        storedMessages() {
            return this.$store.state.orderMessagesStore.messages
        },

        storedAttachments() {
            return this.$store.state.orderAttachmentsStore.attachments
        },

        attachmentsChanged() {
            return this.$store.state.orderAttachmentsStore.itemsChanged
        },

        itemsChanged() {
            return this.$store.state.orderItemStore.itemsChanged
        },

        messagesChanged() {
            return this.$store.state.orderMessagesStore.itemsChanged
        },

        showUpdateBtn() {
            return this.hasPermissionUpdate && !this.isNew && this.tabIdx <= 4
        },

        showLocationBtn() {
            const { hasPermissionUpdate } = this
            return hasPermissionUpdate && this.activeAccordion == 'location'
        },
        taskTypeValue() {
            const taskTypeValue = this.$store.getters['company/taskTypeValue']
            console.log('computed taskTypeValue', taskTypeValue)
            return taskTypeValue
        },

        taskTypeKey() {
            return this.$store.state.company.settingKeys.taskTypeKey
        },
    },

    watch: {
        order: {
            handler: function () {
                this.previousModel = null
            },
            deep: true,
        },
        $route() {
            const id = parseInt(this.$route.params.id)
            console.log('$route watch id', id)
            this.fetchOrderAssets(id)
        },

        tabIdx: function (idx) {
            console.log('tabIdx', idx)
            if (idx === 2) {
                console.log('')
            }
        },
    },
    async created() {
        EventBus.$on('set-order-model', ({ order, driverModified }) => {
            console.log('orderModel--viewOrder', order)
            console.log('modified officer', driverModified)
            this.driverModified = driverModified
            this.order_type_id = order && order.order_type_id
            this.order_template_id = order && order.order_template_id
            this.$nextTick(() => {
                this.setDeliveryLocation(order)
                this.getCustomerAllAssets(order.customer_id)
            })
        })

        EventBus.$on('update-order-template', evt => {
            console.log('update-order-template', evt)
            this.order_template_id = evt
        })

        try {
            this.is_mounting = true
            await this.$store.dispatch('additionalField/fetchAll', {
                module_for: 1,
            })
            await this.$store.dispatch('interactionType/fetchAll')
            await this.$store.dispatch('progressStatus/fetchAll')
            await this.$store.dispatch('orderTemplate/fetchAll')
            await this.$store.dispatch('orderType/fetchAll'),
                await this.$store.dispatch('requestCategory/fetchAll')
            await this.$store.dispatch('checkoffTypes/fetchAll')
            await this.$store.dispatch('users/fetchAll')
            await this.$store.dispatch('customerAgents/fetchAll')

            const id = parseInt(this.$route.params.id)
            await this.fetchOrderAssets(id)
        } catch (err) {
            console.log('viewOrder created err', err)
        } finally {
            this.is_mounting = false
        }
    },

    mounted() {
        this.$store.dispatch('company/fetchConfiguration', this.taskTypeKey)
    },
    methods: {
        filterStatusName(item) {
            return item.completed
                ? this.$translate('completed')
                : item.released
                ? this.$translate('processing')
                : this.$translate('pending')
        },
        activateAccordion(section) {
            if (this.activeAccordion === section) {
                this.activeAccordion = null
            } else {
                this.activeAccordion = section
            }
        },
        processReport(type, title) {
            this.reportStatment = { type, title }
            this.$refs.reportsDialog.show()
        },

        cancel() {
            this.$router.push('/ams/activities')
        },

        changeOrder(id) {
            this.activeAccordion = 'summary'
            this.$router.push(`/ams/activities/${id}`)
        },

        setLocationSearchMode() {
            EventBus.$emit('set-location-search-mode')
        },
        setDeliveryLocation(orderModel) {
            let { isNew, previousModel, order } = this
            if (
                isNew &&
                (!previousModel ||
                    previousModel.customer_id !== orderModel.customer_id)
            ) {
                this.delivery_location_section_id =
                    (orderModel &&
                        orderModel.customer &&
                        orderModel.customer.location_section_id) ||
                    null
            } else if (!isNew && !previousModel) {
                this.delivery_location_section_id =
                    order && order.delivery_location_section_id
            }
            this.previousModel = { ...orderModel }
        },
        cancelOrder() {
            this.$router.push('/ams/activities')
        },
        toggleView() {
            this.viewMode = !this.viewMode
        },
        launchNewOrder() {
            this.$router.push('/ams/activities/0')
        },
        showOrderTemplateModal() {
            this.$refs['ord-sum-ref'].showOrderTemplateModal()
        },
        async downloadPdf(statement_type) {
            try {
                this.toggleOverlay = true
                const { orderId: order_id } = this
                const fileName = 'statement.pdf'
                await this.$store.dispatch('js_report/downloadStatement', {
                    order_id,
                    statement_type,
                    fileName,
                })
            } catch (error) {
                console.error('downloadPdf:', error)
                this.doToast(
                    this.$translate('error'),
                    this.$translate('error_download'),
                    'danger'
                )
            } finally {
                this.toggleOverlay = false
            }
        },

        async fetchOrderAssets(id) {
            if (id) {
                await this.$store.dispatch('orders/fetchById', id)
                await this.$store.dispatch('orders/fetchOrderItems', id)
            } else {
                this.$store.commit('orders/SET_ORDER', {})
                this.$store.commit('orders/SET_ORDER_ITEMS', [])
            }
        },

        buildDuplicateOrder(order_type_id) {
            const {
                customer_id,
                driver_id,
                order_type_id: p_order_type_id,
                description,
                delivery_location_section_id,
                request_category_id,
                signature,
                items,
            } = this.order
            if (!customer_id)
                throw new Error(this.$translate('customer_not_assined'))
            if (!items || items.length == 0)
                throw new Error(this.$translate('items_not_assined'))

            order_type_id = order_type_id || p_order_type_id

            const model = {
                customer_id,
                driver_id,
                description,
                order_type_id,
                delivery_location_section_id,
                request_category_id,
                signature,
            }

            model.duplicate_order_id = this.order.id
            model.schedule_at = this.getLaravelFrLocalParts()
            return model
        },

        async openConvertOTModal() {
            this.isConvertOrderType = true
        },

        async convertOrderType() {
            try {
                this.toggleOverlay = true

                const { new_order_type_id } = this

                const model = this.buildDuplicateOrder(new_order_type_id)

                const data = await this.$store.dispatch('orders/create', model)

                console.log('created data', data)
                this.doToast(
                    this.$translate('success'),
                    `${this.$translate('activity')} ${
                        data.reference_no
                    } ${this.$translate('create_alert')}`,
                    'success'
                )

                this.isConvertOrderType = false
                this.$router.push(`/ams/activities/${data.id}`)
            } catch (err) {
                console.log(err)
                this.doToast(this.$translate('invalid'), err.message, 'danger')
            } finally {
                this.toggleOverlay = false
            }
        },

        runSaveAction() {
            if (this.activeAccordion == 'summary') {
                this.updateOrder()
            }
            if (this.activeAccordion == 'location') {
                this.updateOrder()
            }
            if (this.activeAccordion == 'details') {
                this.updateOrderItems()
            }
            if (this.activeAccordion == 'messages') {
                this.updateNotes()
            }

            if (this.activeAccordion == 'attachments') {
                this.updateAttachments()
            }
        },

        async updateAttachments() {
            const saveAttachment = async payload => {
                payload.order_id = this.order.id
                await this.$store.dispatch('orders/addAttachment', payload)
            }

            const deleteAttachment = async id => {
                await this.$store.dispatch('orders/deleteAttachment', {
                    order_id: this.order.id,
                    attachment_id: id,
                })
            }

            try {
                this.updating = true
                const { storedAttachments: newAttachments } = this
                const markedDeletedArray = []
                for (const oldAttachment of this.order.attachments) {
                    if (
                        !newAttachments
                            .filter(x => !!x.id)
                            .find(x => x.id == oldAttachment.id)
                    ) {
                        markedDeletedArray.push(oldAttachment.id)
                    }
                }
                //delete messages
                await Promise.all(markedDeletedArray.map(deleteAttachment))
                //create messages
                await Promise.all(
                    newAttachments.filter(x => !x.id).map(saveAttachment)
                )
                await this.$store.dispatch('orders/fetchById', this.order.id)
            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.updating = false
            }
        },

        async updateNotes() {
            console.log('checkUpdateNotes')
            const createNote = async content => {
                await api.createNote(this.order.id, content)
            }

            const deleteNote = async id => {
                await api.deleteNote(this.order.id, id)
            }
            try {
                this.updating = true
                const { storedMessages: newNotes } = this
                const markedDeletedArray = []
                for (const oldNote of this.order.notes) {
                    if (
                        !newNotes
                            .filter(x => !!x.id)
                            .find(x => x.id == oldNote.id)
                    ) {
                        markedDeletedArray.push(oldNote.id)
                    }
                }
                //delete messages
                await Promise.all(markedDeletedArray.map(deleteNote))
                //create messages
                await Promise.all(
                    newNotes.filter(x => !x.id).map(x => createNote(x.content))
                )
                await this.$store.dispatch('orders/fetchById', this.order.id)
            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.updating = false
            }
        },

        async updateOrderItems() {
            if (this.orderChanged == true) {
                const { arrangedItems: items } = this
                await this.$store
                    .dispatch('orders/updateItemOrder', { items })
                    .then(() => {
                        this.doToast(
                            this.$translate('updated'),
                            `${this.$translate('activity')} ${this.$translate(
                                'update_alert'
                            )}`,
                            'success'
                        )
                    })
            } else {
                try {
                    this.updating = true
                    const model = this.$refs['ord-sum-ref'].getModel()
                    const { id } = model
                    const total = 0
                    const { storedItems: items } = this
                    await this.$store.dispatch('orders/updateOrderItems', {
                        id,
                        items,
                        total,
                    })
                    this.genericToast(
                        this.$translate('details'),
                        this.$translate('updated'),
                        'success',
                        `${this.$translate('details')} ${this.$translate(
                            'save_alert'
                        )}`
                    )
                } catch (error) {
                    this.doToast(
                        this.$translate('error'),
                        error.message,
                        'danger'
                    )
                } finally {
                    this.updating = false
                }
            }
        },

        async createNewOrder() {
            try {
                this.updating = true
                const summary = this.$refs['ord-sum-ref'].getModel()
                const {
                    storedItems: items,
                    storedMessages: _notes,
                    storedAttachments: attachments,
                    delivery_location_section_id,
                    deliveryLocation,
                    order_template_id,
                } = this

                console.log(
                    'delivery location section id',
                    delivery_location_section_id
                )
                const notes = _notes && _notes.map(x => x.content)
                console.log('deliveryLocation', deliveryLocation)
                const model = {
                    ...summary,
                    ...deliveryLocation,
                    items,
                    notes,
                    attachments,
                    delivery_location_section_id,
                    order_template_id,
                }
                model.schedule_at = this.getLaravelFrLocalParts(
                    model.date,
                    model.time
                )
                model.signature = model.signature || false
                delete model.date
                delete model.time

                console.log('modelssss', model)

                await this.$refs['ord-sum-ref'].validateOrderSummary()

                const data = await this.$store.dispatch('orders/create', model)
                this.doToast(
                    this.$translate('success'),
                    `${this.$translate('activity')} ${
                        data.reference_no
                    } ${this.$translate('create_alert')}`,
                    'success'
                )
                await this.$store.dispatch('orderItemStore/deleteTemplate')
                await this.$store.commit('orders/SET_ORDER', {})
                this.$router.push(`/ams/activities/${data.id}`)
            } catch (err) {
                console.error('createNewOrder', err)
                //"SQLSTATE[23000]: Integrity constraint violation: 1062 Duplicate entry 'Del-110' for key 'orders_reference_no_unique' (SQL: insert into `orders` (`request_category_id`, `customer_id`, `driver_id`, `description`, `delivery_location_section_id`, `created_by`, `schedule_at`, `signature`, `order_type_id`, `reference_no`, `order_template_id`, `linked_assets`, `updated_at`, `created_at`) values (3, 1, 18, testr, 5, 1, 2022-11-11 09:30:00, 0, 1, Del-110, , [], 2022-11-10 20:58:00, 2022-11-10 20:58:00))"
                const duplicateCustomerName = 'Duplicate Name'
                const invalidCustomerNameMsg =
                    "Cannot read properties of undefined (reading 'name')"
                let message = err.message

                if (message == duplicateCustomerName) {
                    message = this.$translate('customer_name_exists')
                }
                if (message == invalidCustomerNameMsg) {
                    message = this.$translate('customer_name_required')
                }

                if (
                    message.indexOf('Duplicate entry') >= 0 &&
                    message.indexOf('orders_reference_no_unique') >= 0
                ) {
                    message = this.$translate('duplicate_reference')
                }

                this.doToast(this.$translate('invalid'), message, 'danger')
            } finally {
                this.updating = false
            }
        },

        async updateOrder() {
            try {
                const {
                    delivery_location_section_id,
                    deliveryLocation,
                    order_template_id,
                } = this
                const summary = { ...this.$refs['ord-sum-ref'].getModel() }

                const { date, time, signature } = summary

                delete summary.date
                delete summary.time

                const schedule_at = this.getLaravelFrLocalParts(date, time)

                summary.signature = signature ? 1 : 0

                const updateModel = {
                    ...summary,
                    ...deliveryLocation,
                    delivery_location_section_id,
                    schedule_at,
                    order_template_id,
                }

                console.log('updateModel:', updateModel)
                this.updating = true

                await this.$store.dispatch('orders/update', updateModel)
                let toastComponentName = this.$translate('activity')

                if (this.driverModified == true) {
                    toastComponentName = this.$translate('officer')
                }
                this.genericToast(
                    this.componentName,
                    this.$translate('updated'),
                    'success',
                    `${toastComponentName} ${this.$translate('update_alert')}`
                )
                this.driverModified = false
                this.viewMode = true
                this.$forceUpdate()
            } catch (error) {
                console.error('update', error)
                let message = error.message || this.$translate('error_updating_activity')
                this.doToast(
                    this.$translate('error'),
                    message,
                    'danger'
                )
            } finally {
                console.log('done bingo bye')
                this.updating = false
            }
        },

        currency(num) {
            num = parseFloat(num)
            console.log('num.......', num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        toggleCompletion() {
            if (this.order.completed) {
                this.markAsIncomplete()
            } else {
                this.markAsComplete()
            }
        },
        async releaseActivity() {
            const title = this.$translate('release_activity_title')
            const message = this.$translate(`release_activity_note`)
            const result = await this.confirmMessage(title, message)
            if (result) {
                try {
                    await this.$store.dispatch(
                        'orders/markAsRelease',
                        this.$route.params.id
                    )

                    this.doToast(
                        this.$translate('success'),
                        this.$translate('activity_released'),
                        'success'
                    )
                } catch (error) {
                    this.doToast(
                        this.$translate('error'),
                        this.$translate('activity_released_error'),
                        'danger'
                    )
                }
            }
        },
        async markAsComplete() {
            const title = this.$translate('mark_as_complete_title')
            const message = this.$translate(`mark_as_complete_note`)
            const result = await this.confirmMessage(title, message)
            if (!result) return
            navigator.geolocation.getCurrentPosition(async p => {
                try {
                    this.updating = true
                    const id = this.$route.params.id
                    var lat = p.coords.latitude
                    var long = p.coords.longitude
                    const getAddress = await this.$store.dispatch(
                        'orders/geocodeStreet',
                        { lat, long }
                    )
                    const address = {
                        lat: p.coords.latitude,
                        long: p.coords.longitude,
                        signature_address: getAddress[0].display_name,
                    }
                    // console.log("Add",Address)
                    await this.$store.dispatch('orders/markAsComplete', {
                        id,
                        address,
                    })
                    this.genericToast(
                        this.componentName,
                        this.$translate('updated'),
                        'success',
                        this.$translate('activity_complete')
                    )
                } catch (error) {
                    console.error('mark as complete', error)
                    this.doToast(
                        this.$translate('error'),
                        error.message,
                        'danger'
                    )
                } finally {
                    this.updating = false
                }
            })
        },
        async markAsIncomplete() {
            const title = this.$translate('mark_as_incomplete')
            const message = this.$translate(`mark_as_incomplete_title`)
            const result = await this.confirmMessage(title, message)
            if (!result) return

            try {
                this.updating = true
                await this.$store.dispatch(
                    'orders/markAsIncomplete',
                    this.$route.params.id
                )

                this.genericToast(
                    this.componentName,
                    this.$translate('updated'),
                    'success',
                    this.$translate('activity_incomplete')
                )
            } catch (error) {
                console.error('markAsIncomplete', error)
                this.doToast(
                    this.$translate('error'),
                    this.$translate('activity_incomplete_error'),
                    'danger'
                )
            } finally {
                this.updating = false
            }
        },

        deleteOrder() {
            // Initializing key variables
            const { id } = this.order
            const name = this.$translate('activity')
            const model = { id, name }

            const routes = {
                baseRoute: '/orders',
                deleteRoute: 'orders/delete',
            }
            const notificationFields = {
                type: this.$translate('activity'),
                errorMsg: this.$translate('unable_to_delete_activity'),
            }

            this.deleteItem(notificationFields, model, routes)
        },

        async getCustomerAllAssets(customer_id) {
            const $this = this
            this.customerAssets.splice(0)
            if (!customer_id) return

            console.log('getCustomerAllAssets customer_id', customer_id)

            const asyncNextTick = () => {
                return new Promise(resolve => {
                    $this.$nextTick(() => resolve())
                })
            }

            const query = ''
            const filters = { customer_id }

            let assets = []
            let page = 1
            do {
                await this.$store.dispatch('assets/fetch', {
                    query,
                    page,
                    filters,
                })

                await asyncNextTick()

                const { assets } = this.$store.state.assets
                page++

                for (const asset of assets) {
                    const { id, name, serial_no } = asset
                    if (!this.customerAssets.some(x => x.id == id))
                        this.customerAssets.push({ id, name, serial_no })
                }
                // code block to be executed
            } while (assets.length > 0)
            console.log('getCustomerAllAssets ', this.customerAssets)
        },
    },
}
</script>
